import React from 'react';
import { BLOCK_WIDTH, BLOCK_HEIGHT } from './WorkflowEditor';
import { DeleteIcon, AddChildIcon } from './Icon';
import './Node.scss';
import { NodeType, BlockType } from './models';

interface NodeProps {
  node: NodeType;
  onDeleteNode: (nodeId: string) => void;
  onBlockRightClick: (e: React.MouseEvent, nodeId: string) => void;
  onMouseDown: (e: React.MouseEvent, nodeId: string) => void;
  onClick?: (nodeId: string) => void;
}

const Node: React.FC<NodeProps> = ({
  node,
  onDeleteNode,
  onBlockRightClick,
  onMouseDown,
  onClick,
}) => {
  const isStart = node.type === BlockType.START;
  return (
    <g
      key={node.id}
      transform={`translate(${node.position.x},${node.position.y})`}
      onMouseDown={e => onMouseDown(e, node.id)}
      onClick={() => onClick && onClick(node.id)}>
      <rect
        width={BLOCK_WIDTH}
        height={BLOCK_HEIGHT}
        fill={isStart ? '#2c3e50' : '#4CAF50'}
        rx={14}
      />
      <foreignObject
        x={16}
        y={16}
        width={BLOCK_WIDTH - 32}
        height={BLOCK_HEIGHT - 32}
        className="pointer-events-none">
        <div
          className={`node-label-container ${isStart ? 'start-node' : 'other-node'}`}>
          {node.type.replace(/_/g, ' ').toUpperCase()}
        </div>
      </foreignObject>
      {!isStart && node.type !== BlockType.GENERAL && (
        <DeleteIcon
          cx={0}
          cy={BLOCK_HEIGHT / 2}
          r={13}
          onClick={e => {
            e.stopPropagation();
            onDeleteNode(node.id);
          }}
        />
      )}
      {isStart && (
        <AddChildIcon
          x={BLOCK_WIDTH - 18}
          y={BLOCK_HEIGHT / 2 - 10}
          width={20}
          height={20}
          onClick={e => onBlockRightClick(e, node.id)}
        />
      )}
    </g>
  );
};

export default Node;
